import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';

import active_guide from 'images/active_guide.png';
import insulin_guide from 'images/insulin_guide.png';
import meal_guide from 'images/meal_guide.png';
import HBox from 'components/common/HBox';

const images = {
  active_guide,
  meal_guide,
  insulin_guide,
};

export default function EditArea(props) {
  const {
    id,
    caption,
    rows = 6,
    register,
    disabled,
    ...rest
  } = props;
  return (
    <HBox {...ex('EditArea', rest)}>
      <div>
        <img src={images[id]} alt={id} />
      </div>
      <VBox full>
        <div>
          {caption}
        </div>
        <VBox full>
          <textarea
            {...{ rows }}
            {...register(id, {
              rows,
              placeholder: T('{0}를 입력하세요.', caption),
              disabled,
            })}
          />
        </VBox>
      </VBox>
    </HBox>
  );
}
